import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-upload-asset-dialog',
  templateUrl: './upload-asset-dialog.component.html',
  styleUrls: ['./upload-asset-dialog.component.scss']
})
export class UploadAssetDialogComponent {
selectedFile: File | null = null;

constructor(
    public dialogRef: MatDialogRef<UploadAssetDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private matSnackBar: MatSnackBar,
  ) {}

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.selectedFile = input.files?.[0] ?? null;
  }

  upload(): void {
    if (this.selectedFile) {
      if (this.isFileSizeExceeded(this.selectedFile)) {
        this.matSnackBar.open(
          'File Size has been exceeded',
          'Error',
          { verticalPosition: 'top', panelClass: ['snackbar-error'] }
        );
        return;
      }
      this.dialogRef.close(this.selectedFile);
    }
  }

  isFileSizeExceeded(file: any): boolean {
    let fileSize = file.size;
    let type = file.type;
    if (type == "video/mp4" || type == "application/x-zip-compressed") {
      if (fileSize > 256 * 1024 * 1024) {
        return true;
      }
    }
    else {
      if (fileSize > 40 * 1024 * 1024) {
        return true;
      }
    }
    return false;
  }
}
